import { z } from 'zod';

const objectForSelection = {
  id: z.number(),
  label: z.string()
};

export const OperationTypeSchema = z.object({
  id: z.number().or(z.string()),
  operationName: z
    .string()
    .nonempty({ message: 'Пожалуйста, укажите название работы' })
    .max(100, { message: 'До 100 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    }),
  // measure: z.object(objectForSelection).optional()
  effort: z.number({
    invalid_type_error: 'Введите число' 
  })
    .max(100000, { message: 'Значение должно быть меньше чем 100000' })
    .optional()
    .nullable(),
});
